import { forwardRef } from "react";
import type { HTMLAttributes } from "react";

interface DashboardContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const DashboardContainer = forwardRef<HTMLDivElement, DashboardContainerProps>(
  ({ children, className = "", ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 ${className}`}
        {...props}
      >
        {children}
      </div>
    );
  }
);

DashboardContainer.displayName = "DashboardContainer";

export default DashboardContainer;
